export const config = {
  eventGroup: 'js4_gczd_mo_20260929',
  name: '《剑侠世界4》公测组队活动小程序套壳MO',
  identify: 'js4',
  eventTags: ['js4', 'gczd', 'mo']
};

export default function createTracker(report, getDiffRouteTime) {
  return {
    loadPage: function() {
      report({
        eventName: 'load_page',
        eventDescription: '页面加载(默认上报，页面全部加载完才上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    pageLeave: function() {
      report({
        eventName: 'page_leave',
        eventDescription: '离开页面(默认上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    loadPageStart: function() {
      report({
        eventName: 'load_page_start',
        eventDescription: '页面加载(默认上报，进入页面就上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    /**
     * @param {string} [source] - 访问来源：direct、poster_qr、invite_link、recall_sms
     * @param {string} [reqId] - 来源队伍ID，取 from_team_id
     */
    pageActivityHome: function(source, reqId) {
      report({
        eventName: 'page_activity_home',
        eventDescription: '活动首页曝光',
        eventDataValue: {
          source: source,
          req_id: reqId
        },
        types: {
          source: checkTypeHOF('string'),
          req_id: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [source] - 访问来源：direct、poster_qr、invite_link、recall_sms
     */
    pageTeamAssembly: function(source) {
      report({
        eventName: 'page_team_assembly',
        eventDescription: '组队集结页曝光',
        eventDataValue: {
          source: source
        },
        types: {
          source: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [source] - 创建来源：team_page、review_summary
     * @param {string} [status] - 结果：success、fail
     * @param {string} [statusReason] - 失败原因：team_exists、activity_ended、qualification_invalid、server_error
     */
    clickCreateTeam: function(source, status, statusReason) {
      report({
        eventName: 'click_create_team',
        eventDescription: '点击创建队伍',
        eventDataValue: {
          source: source,
          status: status,
          status_reason: statusReason
        },
        types: {
          source: checkTypeHOF('string'),
          status: checkTypeHOF('string'),
          status_reason: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 入口名称：生成队伍邀约海报、邀请好友席位、分享、邀请入队
     */
    clickInviteEntry: function(title) {
      report({
        eventName: 'click_invite_entry',
        eventDescription: '点击邀请好友',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [kinds] - 海报二维码类型：team、activity_home、game_download
     */
    pagePosterEditor: function(kinds) {
      report({
        eventName: 'page_poster_editor',
        eventDescription: '海报编辑页曝光',
        eventDataValue: {
          kinds: kinds
        },
        types: {
          kinds: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [type] - 操作方式：save_poster、copy_link
     * @param {string} [kinds] - 海报类型：team、activity_home、game_download
     * @param {string} [reqId] - 来源队伍ID，取 team_id
     */
    clickSharePoster: function(type, kinds, reqId) {
      report({
        eventName: 'click_share_poster',
        eventDescription: '点击海报分享操作',
        eventDataValue: {
          type: type,
          kinds: kinds,
          req_id: reqId
        },
        types: {
          type: checkTypeHOF('string'),
          kinds: checkTypeHOF('string'),
          req_id: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [source] - 客态来源：poster_qr、invite_link、recall_sms
     * @param {string} [reqId] - 来源队伍ID，取 from_team_id
     * @param {string} [ext] - 邀请人标识，取分享参数 share_code
     */
    pageGuestJoinPage: function(source, reqId, ext) {
      report({
        eventName: 'page_guest_join_page',
        eventDescription: '入队客态页曝光',
        eventDataValue: {
          source: source,
          req_id: reqId,
          ext: ext
        },
        types: {
          source: checkTypeHOF('string'),
          req_id: checkTypeHOF('string'),
          ext: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [source] - 客态来源：poster_qr、invite_link、recall_sms
     * @param {string} [reqId] - 来源队伍ID，取 from_team_id
     * @param {string} [ext] - 邀请人标识，取分享参数 share_code
     */
    clickGuestJoinTeam: function(source, reqId, ext) {
      report({
        eventName: 'click_guest_join_team',
        eventDescription: '点击客态页加入队伍',
        eventDataValue: {
          source: source,
          req_id: reqId,
          ext: ext
        },
        types: {
          source: checkTypeHOF('string'),
          req_id: checkTypeHOF('string'),
          ext: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [source] - 客态来源：poster_qr、invite_link、recall_sms
     * @param {string} [reqId] - 来源队伍ID，取 from_team_id
     * @param {string} [ext] - 邀请人标识，取分享参数 share_code
     * @param {string} [status] - 结果：success、fail
     * @param {string} [statusReason] - 失败原因：already_in_team、team_full、team_invalid、qualification_invalid、activity_ended、server_error
     */
    clickConfirmJoinTeam: function(source, reqId, ext, status, statusReason) {
      report({
        eventName: 'click_confirm_join_team',
        eventDescription: '点击确认加入队伍(二次确认)',
        eventDataValue: {
          source: source,
          req_id: reqId,
          ext: ext,
          status: status,
          status_reason: statusReason
        },
        types: {
          source: checkTypeHOF('string'),
          req_id: checkTypeHOF('string'),
          ext: checkTypeHOF('string'),
          status: checkTypeHOF('string'),
          status_reason: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [ext] - 可召回好友数量：十进制整数字符串
     */
    pageRecallFriendList: function(ext) {
      report({
        eventName: 'page_recall_friend_list',
        eventDescription: '好友召回列表曝光',
        eventDataValue: {
          ext: ext
        },
        types: {
          ext: checkTypeHOF('string')
        }
      });
    },
    clickRecallFriend: function() {
      report({
        eventName: 'click_recall_friend',
        eventDescription: '点击召回好友'
      });
    },
    pageActivityBag: function() {
      report({
        eventName: 'page_activity_bag',
        eventDescription: '活动背包页曝光'
      });
    },
    /**
     * @param {string} [status] - 结果：success、fail
     * @param {string} [statusReason] - 失败原因：not_eligible、not_open、role_unbound、already_claimed、server_error
     */
    clickClaimReward: function(status, statusReason) {
      report({
        eventName: 'click_claim_reward',
        eventDescription: '点击领取奖励',
        eventDataValue: {
          status: status,
          status_reason: statusReason
        },
        types: {
          status: checkTypeHOF('string'),
          status_reason: checkTypeHOF('string')
        }
      });
    },
    clickConfirmRewardRole: function() {
      report({
        eventName: 'click_confirm_reward_role',
        eventDescription: '确认绑定领奖角色'
      });
    },
    /**
     * @param {string} [kinds] - 回顾类型：first、repeat
     */
    pageReviewHome: function(kinds) {
      report({
        eventName: 'page_review_home',
        eventDescription: '老玩家回顾首页曝光',
        eventDataValue: {
          kinds: kinds
        },
        types: {
          kinds: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [kinds] - 回顾类型：first、repeat
     */
    clickStartReview: function(kinds) {
      report({
        eventName: 'click_start_review',
        eventDescription: '点击前往回顾',
        eventDataValue: {
          kinds: kinds
        },
        types: {
          kinds: checkTypeHOF('string')
        }
      });
    },
    clickSkipReview: function() {
      report({
        eventName: 'click_skip_review',
        eventDescription: '点击跳过回顾'
      });
    }
  };
}

Number.isInteger =
  Number.isInteger ||
  function(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };

function checkTypeHOF(type) {
  switch (type) {
    case 'int':
      return Number.isInteger;
    case 'float':
      return value => typeof value === 'number' && !Number.isInteger(value);
    case 'boolean':
      return value => typeof value === 'boolean';
    case 'string':
      return value => typeof value === 'string';
    default:
      setTimeout(() => {
        throw new Error('st-report: invalid value type = ' + type);
      }, 0);
      return null;
  }
}
